exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.a{color:#fff\n}\n.top-right{position:absolute;top:0px;right:0px;z-index:2;padding:5px\n}\n@media only screen and (min-device-width: 320px)and (max-device-width: 667px){\n.top-right{right:5px\n}\n}\n.scroll{min-height:200px;max-height:400px;overflow-y:auto\n}", ""]);

// exports
